import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { rem, mediaUp } from 'approot/shared/style';
import { grey1, grey3, red7 } from 'approot/shared/styles/colours.style';
import { fontWeightMedium } from 'approot/shared/styles/typography.style';
import {
  borderRadius8,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { spacing12, spacing16 } from 'approot/shared/styles/spacing.style';
import {
  LAYOUT_HEADER_HEIGHT,
  baseLayoutBounds,
} from 'approot/shared/layout/layout.styles';
import { NavigationMenuIconButton } from '../navigation/navigation-icon-button.style';
import { PrintHidden } from 'approot/shared/styles/print.style';
import { SecondaryButtonLink } from 'approot/shared/styles/buttons/secondary-button.style';
import { LAYOUT_HEADER_Z_INDEX } from '../layout.constants';

export type HeaderProps = {
  top?: number;
};
export const baseHeaderStyles = css<HeaderProps>`
  align-items: center;
  background-color: ${grey1};
  border-bottom: 1px solid ${grey3};
  box-sizing: border-box;
  display: flex;
  height: ${rem(LAYOUT_HEADER_HEIGHT)};
  left: 0;
  position: sticky;
  width: 100vw;
  top: ${({ top = 0 }) => rem(top)};
  z-index: ${LAYOUT_HEADER_Z_INDEX};

  ${baseLayoutBounds}

  ${mediaUp.xl`
    padding-left: ${rem(spacing16)};
    padding-right: ${rem(spacing16)};
  `}
`;

export const HeaderLogoStyled = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  user-select: none;
  max-height: ${rem(40)};
  width: ${rem(108)};
  z-index: 101;

  ${mediaUp.md`
    width: ${rem(126)};
  `}

  img {
    display: block;
    width: 100%;
  }
`;

export const HeaderStyled = styled.header<HeaderProps>`
  ${baseHeaderStyles}
`;

export const SimpleHeaderStyled = styled.header<HeaderProps>`
  ${baseHeaderStyles}

  justify-content: space-between;

  ${HeaderLogoStyled} {
    position: relative;
  }

  ${PrintHidden}
`;

export const HeaderLogoLinkStyled = styled(Link)`
  border-radius: ${rem(8)};
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  ${standardFocusState}
`;

export const DevEnvNotice = styled.div`
  background-color: ${red7};
  color: ${grey1};
  font-size: ${rem(12)};
  font-weight: ${fontWeightMedium};
  height: ${rem(12)};
  left: 0;
  top: 0;
  position: fixed;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  z-index: 103;

  ${PrintHidden}
`;

export const HeaderSecondarySearch = styled(SecondaryButtonLink)`
  display: block;
  border-radius: ${rem(borderRadius8)};
  min-width: ${rem(40)};
  padding-left: 0;
  padding-right: 0;
`;

type HeaderContainerProps = {
  isAuthenticated?: boolean;
} & HeaderProps;
export const HeaderContainerStyled = styled.header<HeaderContainerProps>`
  ${baseHeaderStyles}

  ${HeaderLogoStyled} {
    left: ${({ isAuthenticated }) => (isAuthenticated ? rem(60) : rem(104))};
  }

  ${mediaUp.md<HeaderContainerProps>`
    ${({ isAuthenticated }) =>
      isAuthenticated &&
      `
      ${NavigationMenuIconButton} {
        display: none;
      }
      ${HeaderLogoStyled} {
        left: 0;
      }
    `}
  `}
`;

export const HeaderInnerContainerStyled = styled.div`
  display: flex;
  align-items: center;
  height: ${rem(40)};
  padding-left: ${rem(146)};
  position: relative;
  width: 100%;

  ${mediaUp.xl`
    padding-left: ${rem(128)};
  `}

  @media (min-width: 1400px) {
    padding-left: ${rem(166)};
  }

  ${NavigationMenuIconButton} {
    position: absolute;
    left: 0;
  }

  ${NavigationMenuIconButton} {
    top: ${rem(3)};
  }
`;

export const HeaderSecondaryActions = styled.div`
  display: flex;
  gap: ${rem(spacing12)};
  position: absolute;
  right: 0;
  top: 0;
`;
